module.exports = __webpack_public_path__ + "img/cow-hollow-inn.7d8652eb.jpg";